/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_What_BodyInputs */

const en_fw_guide_what_body = /** @type {(inputs: Fw_Guide_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firefly Wedding, known in Japan as Hotaru no Yomeiri, is a historical romance manga by Oreco Tachibana. It is set in Meiji-era Japan and follows Satoko Kirigaya, an earl’s daughter with a failing heart, and Shinpei Gotō, the assassin hired to kill her. Instead of begging for her life, Satoko proposes to him. The series ran on Shogakukan’s Ura Sunday site and the MangaONE app from January 2023, and the main story concluded in February 2026. Firefly Wedding has passed four million copies in print and has collected a string of reader awards, which is a big part of why the Firefly Wedding anime was one of the most anticipated adaptations of the year.`)
};

const zh_fw_guide_what_body = /** @type {(inputs: Fw_Guide_What_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁（日文原名《ホタルの嫁入り》）是橘オレコ创作的历史浪漫漫画。故事发生在明治时代的日本，主角是患有心脏病的伯爵千金桐ヶ谷紗都子，以及受雇来杀她的杀手後藤進平。紗都子没有求饶，而是向他求婚。作品自 2023 年 1 月起在小学馆「裏サンデー」与「マンガワン」连载，本篇于 2026 年 2 月完结，累计发行突破 400 万部并屡获读者奖项，这也是萤火之嫁动画成为年度最受期待改编作品之一的重要原因。`)
};

/**
* | output |
* | --- |
* | "Firefly Wedding, known in Japan as Hotaru no Yomeiri, is a historical romance manga by Oreco Tachibana. It is set in Meiji-era Japan and follows Satoko Kirig..." |
*
* @param {Fw_Guide_What_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_what_body = /** @type {((inputs?: Fw_Guide_What_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_What_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_what_body(inputs)
	return zh_fw_guide_what_body(inputs)
});
export { fw_guide_what_body as "fw.guide.what.body" }